import styled, { css } from 'styled-components'

export const Content = styled.div(
  ({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: ${theme.space['0']} ${theme.space['16']} ${theme.space['16']};
  `,
)

export const Logo = styled.img(
  ({ theme }) => css`
    width: auto;
    height: 6.8rem;
    padding: ${theme.space['4']} ${theme.space['0']};
  `,
)

export const Modules = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['24']};
  `,
)

export const Controls = styled.div(
  ({ theme }) => css`
    position: sticky;
    bottom: 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: ${theme.space['8']};
    margin-top: auto;
    padding: ${theme.space['16']};
    background-color: ${theme.colors.white};
    box-shadow: ${theme.shadow.marketShopShadow};
  `,
)
